import type { LanguageCode } from './languages';

const english = {
  designParameters: 'Design Parameters',
  reset: 'Reset',
  flowRate: 'Design Flow Rate (Q)',
  targetVelocity: 'Target Velocity (v)',
  recommended: 'Recommended',
  pipeMaterial: 'Pipe Material & Standard',
  roughness: 'Roughness',
  pipeLength: 'Pipe Run Length (L)',
  temperature: 'Water Operating Temperature',
  cold: 'Cold',
  room: 'Room',
  hot: 'Hot',
  advanced: 'Advanced: Pipe Fittings & Minor Losses',
  elbows: '90° Elbows',
  tees: 'Tees Through Branch',
  valves: 'Ball Valves',
  recommendedSize: 'Recommended Commercial Pipe Size',
  copy: 'Copy',
  print: 'Print',
  innerDiameter: 'Inner Diameter',
  outerDiameter: 'Outer Diameter',
  wallThickness: 'Wall Thickness',
  requiredBore: 'Required Bore',
  flowVelocity: 'Flow Velocity',
  highVelocity: 'High Velocity',
  lowVelocity: 'Low Velocity',
  optimalVelocity: 'Optimal Velocity',
  pressureDrop: 'Pressure Drop',
  totalHeadLoss: 'Total Head Loss',
  hydraulicGradient: 'Hydraulic Gradient',
  fluidMechanics: 'Fluid Mechanics & Friction Verification',
  reynolds: 'Reynolds Number',
  frictionFactor: 'Friction Factor',
  waterDensity: 'Water Density',
  kinematicViscosity: 'Kinematic Viscosity',
  fullWorking: 'Full Mathematical Working & Substitution Proof',
  theoreticalDiameter: 'Theoretical Internal Diameter via Continuity Equation',
  actualVelocity: 'Actual Velocity in Selected Commercial Pipe',
  reynoldsCheck: 'Reynolds Number Check',
  darcyFactor: 'Darcy Friction Factor (Swamee-Jain)',
  darcyPressure: 'Darcy-Weisbach Friction Pressure Drop',
  validParameters: 'Please enter valid parameters on the left to calculate pipe sizing.',
  invalidFlow: 'Design flow rate must be a positive number greater than 0.',
  invalidVelocity: 'Target velocity must be a positive number greater than 0.',
  invalidLength: 'Pipe run length must be a positive number greater than 0.',
  invalidTemperature: 'Water operating temperature must be between 0°C and 100°C.',
  calculationError: 'Calculation error.',
  copied: 'Engineering Summary Copied to Clipboard',
  summaryGenerated: 'Summary Generated',
  resetDone: 'Parameters Reset to Defaults',
};

const hindi = {
  designParameters: 'डिजाइन पैरामीटर',
  reset: 'रीसेट करें',
  flowRate: 'डिजाइन प्रवाह दर (Q)',
  targetVelocity: 'लक्षित प्रवाह वेग (v)',
  recommended: 'अनुशंसित',
  pipeMaterial: 'पाइप सामग्री और मानक',
  roughness: 'खुरदरापन',
  pipeLength: 'पाइप की लंबाई (L)',
  temperature: 'पानी का ऑपरेटिंग तापमान',
  cold: 'ठंडा',
  room: 'सामान्य',
  hot: 'गर्म',
  advanced: 'एडवांस्ड: पाइप फिटिंग और अतिरिक्त हानि',
  elbows: '90° एल्बो',
  tees: 'टी-जॉइंट (ब्रांच के माध्यम से)',
  valves: 'बॉल वाल्व',
  recommendedSize: 'अनुशंसित कमर्शियल पाइप आकार',
  copy: 'कॉपी करें',
  print: 'प्रिंट करें',
  innerDiameter: 'आंतरिक व्यास',
  outerDiameter: 'बाहरी व्यास',
  wallThickness: 'दीवार की मोटाई',
  requiredBore: 'आवश्यक आंतरिक व्यास',
  flowVelocity: 'प्रवाह वेग',
  highVelocity: 'अधिक वेग',
  lowVelocity: 'कम वेग',
  optimalVelocity: 'उपयुक्त वेग',
  pressureDrop: 'दाब में गिरावट',
  totalHeadLoss: 'कुल हेड लॉस',
  hydraulicGradient: 'हाइड्रोलिक ग्रेडिएंट',
  fluidMechanics: 'द्रव यांत्रिकी और घर्षण की जांच',
  reynolds: 'रेनॉल्ड्स संख्या',
  frictionFactor: 'घर्षण गुणांक',
  waterDensity: 'पानी का घनत्व',
  kinematicViscosity: 'काइनेमैटिक श्यानता',
  fullWorking: 'पूरी गणितीय प्रक्रिया और सूत्र में मान रखना',
  theoreticalDiameter: 'Continuity Equation से सैद्धांतिक आंतरिक व्यास',
  actualVelocity: 'चुने गए कमर्शियल पाइप में वास्तविक वेग',
  reynoldsCheck: 'रेनॉल्ड्स संख्या की जांच',
  darcyFactor: 'डार्सी घर्षण गुणांक (Swamee-Jain)',
  darcyPressure: 'Darcy-Weisbach घर्षण दाब हानि',
  validParameters: 'पाइप का आकार निकालने के लिए बाईं ओर सही पैरामीटर दर्ज करें।',
  invalidFlow: 'डिजाइन प्रवाह दर 0 से अधिक धनात्मक संख्या होनी चाहिए।',
  invalidVelocity: 'लक्षित वेग 0 से अधिक धनात्मक संख्या होना चाहिए।',
  invalidLength: 'पाइप की लंबाई 0 से अधिक होनी चाहिए।',
  invalidTemperature: 'पानी का ऑपरेटिंग तापमान 0°C से 100°C के बीच होना चाहिए।',
  calculationError: 'गणना में त्रुटि हुई।',
  copied: 'इंजीनियरिंग सारांश क्लिपबोर्ड पर कॉपी हो गया।',
  summaryGenerated: 'सारांश तैयार हो गया।',
  resetDone: 'सभी पैरामीटर डिफॉल्ट पर रीसेट हो गए।',
};

export const waterCalculatorTranslations: Partial<
  Record<LanguageCode, typeof english>
> = {
  en: english,
  hi: hindi,
};

export function getWaterCalculatorText(language: LanguageCode) {
  return waterCalculatorTranslations[language] ?? english;
}